<template>
  <div class="py-4 pos-relative">
    <div class="container">
      <div class="text-center main-image animated fadeIn animation-delay-200 mt-1">
        <div class="pos-relative">
          <!-- h1 -->
          <div class="super-container">
            <h1 class="h1 super super-everyone text-dark"><span class="fw-light">{{ $t('music_distribution_for') }}</span> {{ $t('everyone') }}</h1>
          </div>
          <div class="mt-4 computer-container">
            <div class="py-2 bg-primary bar animated fadeIn animation-delay-400"></div>
            <img class="computer" src="/static/img/landing/computer.jpg" alt="Indiefy Distribution Platform" height="250">
          </div>
          <div class="row justify-content-md-center mt-2 stores-row">
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/0-transparent.png" alt="Spotify Distribution" class="img-fluid">
            </div>
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/1-transparent.png" alt="Apple Music Distribution" class="img-fluid">
            </div>
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/2-transparent.png" alt="Deezer Distribution" class="img-fluid">
            </div>
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/3-transparent.png" alt="Beatport Distribution" class="img-fluid">
            </div>
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/4-transparent.png" alt="YouTube Distribution" class="img-fluid">
            </div>
            <div class="col-4 col-md-2">
              <img src="/static/img/landing/stores/7-transparent.png" alt="Amazon Distribution" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="mb-5 mt-4">
          <router-link :to="getLoginUrl('signup-button')" class="btn btn-success" style="z-index: 10;">
            <span>{{ $t('free_signup') }}</span>
          </router-link>
        </div>
      </div>

      <div class="row text-center mt-4 features-columns">
        <div class="col-md-4 animated fadeIn animation-delay-500">
          <h2 class="fw-light">{{ $t('distribution') }}</h2>
          <p class="px-4" v-html="$t('distribution_landing_description')">
          </p>
          <br/>
        </div>
        <div class="col-md-4 animated fadeIn animation-delay-900">
          <h2 class="fw-light">{{ $t('analytics') }}</h2>
          <p class="px-4" v-html="$t('analytics_landing_description')">
          </p>
          <br/>
        </div>
        <div class="col-md-4 animated fadeIn animation-delay-1300">
          <h2 class="fw-light">{{ $t('royalties') }}</h2>
          <p class="px-4" v-html="$t('royalties_landing_description')">
          </p>
          <br/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LandingHome',
  data: function () {
    return {
      isCrawler: false,
      lang: 'en',
      words: [],
      currentWord: 0
    }
  },
  methods: {
    getLoginUrl: function (identifier) {
      let baseUrl = ''

      if (location.host.match(/free-music-distribution/)) {
        baseUrl = 'https://indiefy.net'
      }

      if (this.$user && this.$user._id) {
        return `${baseUrl}/dashboard`
      } else {
        if (this.isCrawler || !identifier) {
          return `${baseUrl}/login`
        }

        if (identifier) {
          return `${baseUrl}/login?from=${identifier}`
        }
      }
    },
    animateText: function () {
      let i = 0
      let txt = this.words[this.currentWord]
      let speed = 100

      if (!this.$refs.word) {
        return
      }

      this.$refs.word.innerHTML = ''

      const typeWriter = () => {
        if (i < txt.length && this.$refs.word) {
          this.$refs.word.innerHTML += txt.charAt(i)
          i++
          setTimeout(typeWriter, speed)
        } else {
          this.currentWord++

          if (this.currentWord > (this.words.length - 1)) {
            this.currentWord = 0
          }

          setTimeout(() => {
            this.animateText()
          }, 1000)
        }
      }

      typeWriter()
    }
  },
  mounted: function () {
    this.animateText()

    setTimeout(() => {
      window.prerenderReady = true
    }, 100)
  },
  created: function () {
    this.isCrawler = navigator.userAgent.match(/bot|googlebot|prerender|crawler|spider|robot|crawling/i)

    if (this.$i18n) {
      this.lang = this.$i18n.locale
    }

    this.words = [
      this.$t('easy'),
      this.$t('cool'),
      this.$t('fast'),
      this.$t('amazing'),
      this.$t('simple')
    ]

    window.document.title = this.$t('landing_title')
    window.$('meta[property="og:title"]').attr('content', this.$t('landing_title'))
    window.$('meta[name="description"]').attr('content', this.$t('landing_description'))
    window.$('meta[property="og:description"]').attr('content', this.$t('landing_description'))
  }
}
</script>
<style lang="scss" scoped>
@media screen and (min-width:320px) and (max-width:360px) {
  .cell-container {
    position: absolute !important;
    top: 15%;
    right: 5%;
    height: 150px !important;

    img {
      height: 150px !important;
    }
  }

  .cell-row .col-text {
    width: 60% !important;
    max-width: 60% !important;
    flex: 0 0 60%;
  }

  .cell-row .col-images {
    width: 40% !important;
    max-width: 40% !important;
    flex: 0 0 40%;
  }

  .super {
    font-size: 2.5em !important;
  }

  .computer {
    height: 200px;
    margin-left: -187px !important;
  }

  .computer-container {
    height: 200px !important;
  }

  .bar {
    top: 55% !important;
  }

  .stores-row {
    margin-top: 0 !important;
  }

  .super-title {
    font-size: 1.6em !important;
  }

  .text-gray {
    width: 93vw;
    font-size: 14px;
  }

  .super-everyone {
    font-size: 2.5em !important;
    max-width: 90vw !important;
  }

}

@media screen and (max-width:576px) and (min-width:361px) {
  .stores-row {
    margin-top: 0 !important;
  }

  .text-gray {
    font-size: 1.2em;
  }

  .cell-row .col-text {
    width: 60% !important;
    max-width: 60% !important;
    flex: 0 0 60%;
  }

  .cell-row .col-images {
    width: 40% !important;
    max-width: 40% !important;
    flex: 0 0 40%;
  }

  .cell-container {
    position: absolute !important;
    top: 15%;
    right: 5%;
    height: 200px !important;

    img {
      height: 200px !important;
    }
  }

  .super-everyone {
    font-size: 2.5em !important;
    max-width: 90vw !important;
  }

  .super-title {
    font-size: 1.8em !important;
  }

  .bar {
    top: 55% !important;
  }

  .pos-relative {
    padding-top: 20px !important;
  }

  .computer {
    height: 200px;
    margin-left: -187px !important;
  }

  .computer-container {
    height: 200px !important;
  }

  .text-gray {
    font-size: 14px;
    width: 94vw;
    display: inline-block;
  }
}

.bar {
  position: absolute;
  top: 55%;
  left: -100%;
  width: 300%;
}

.main-image {
  position: relative;

  .computer {
    position: absolute;
    left: 50%;
    margin-left: -235px;
  }
}

.super-title {
  font-size: 3em;
}

.super-everyone {
  font-size: 4em;
}

.features-columns {
  p {
    font-size: 0.9em;
    color: #8E8E91;
  }
}

.computer-container {
  // overflow: hidden;
  height: 250px;
  width: 100%;
  position: relative;
}

.pos-relative {
  position: relative;
}

.super-title {
  font-size: 3.5em;
}

.fw-extrabold {
  font-size: 1.3em;
}

.cell-container {
  height: 600px;

  img {
    height: 600px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
}

.text-gray {
  color: #bbb;
}

.big {
  font-size: 1.3em;
}

.d-inline {
  display: inline-block;
}

.super-container {
  text-align: center;

  .super-everyone {
    display: inline-block;
    max-width: 50vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LandingHome.vue